/* eslint-disable react/function-component-definition */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import React, {useEffect, useState, useMemo } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useCommonInits } from 'hooks/useCommonInits';
import { useSelector } from 'react-redux';
import {
    Typography,
    Button,
    Box,
    Paper,
    Grid,
} from '@mui/material';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import {
    getAllGroups,
    getApcmGroup,
    getRequestID,
    getYesRequestByGroupIds,
    updateExecuteRequest,
    deleteExecuteRequest,
    getNoExecutedData,
} from 'redux/datasource/dataSourceActions';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import {
    getGroupsbyId,
    getRequestByID,
    getYesPriceRequestByIds,
    getNotExecuted, getGroups, clearPriceRequestMsg
} from 'redux/datasource/dataSourceSlice';
import { getUser, getUnitIds } from 'redux/auth/authSlice';
import { updatePanelContent } from 'redux/panels/panelsSlice';
import ConfirmationModal from 'components/groups/confirmModal';
import { useParams } from 'react-router-dom';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import { ROUTE_PATHS } from 'app/utils/route';
import { AppConfirmDialog } from 'components/common/AppConfirmDialog';
import ExecuteConfirmationModal from './executeConfirmModal';

export const ExecuterID = () => {
    const { id } = useParams();
    const { dispatch, select, navigate } = useCommonInits();
    const Groups = useSelector(getGroups);
    const user = select(getUser);
    const GroupByID = useSelector(getGroupsbyId);
    const [reqName, setReqName] = useState('');
    const [executedBy, setExecutedBy] = useState('');
    const [groupId, setGroupId] = useState('');
    const [groupName, setGroupName] = useState('');
    const [executed, setExecuted] = useState('');
    const [newPrice, setNewPrice] = useState();
    const [oldPrice, setOldPrice] = useState();
    const { isLoading } = useSelector(state => state.shared);
    const [showDialog, setShowDialog] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [deleteData, setDeleteData] = useState({});
    const request = useSelector(getYesPriceRequestByIds);
    const requestById = useSelector(getRequestByID);
    const [reloadBox, setReloadBox] = useState(false);
    const [reloadData, setReloadData] = useState(null);
    const [dateTime, setDateTime] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [successMsg, setSuccessMsg] = useState(false);
    const notExecuted = useSelector(getNotExecuted);
    const units = useSelector(getUnitIds);
    const unitIds = JSON.parse(units);
    const priceExecuteRes = useSelector(state => state?.datasource?.priceExecuteMsg);
    const filteredGroups = Groups?.filter(val => {
        return unitIds.find(a => {
            return val.name === a;
        });
    });
    useEffect(() => {
        if (id) {
            dispatch(getApcmGroup({ id }));
            getData();
        }
    }, [id]);

    useEffect(() => {
        handleData();
    }, [Groups]);

    useEffect(() => {
        return () => {
            if (reloadData) {
                clearInterval(reloadData);
            }
        };
    }, [reloadData]);

    const handleData = () => {
        const params = {
            group_id: filteredGroups.map(group => group._id),
        };
        dispatch(getNoExecutedData(params));
        // setReloadData(reload)

        // return () => {
        //     clearInterval(reloadData);
        // };
    };

    useEffect(() => {
        if (GroupByID) {
            setGroupName(GroupByID?.name);
            setGroupId(GroupByID?._id);
        }
        const params = {
            group_id: id,
        };
        dispatch(getYesRequestByGroupIds(params));
    }, [GroupByID]);

    useEffect(() => {
        if (requestById) {
            setReqName(requestById?.price_request_name);
            setOldPrice(requestById?.old_price);
            setNewPrice(requestById?.price);
            setExecuted(requestById?.executed);
            setDateTime(requestById?.date_time);
            setGroupName(requestById?.group_name);
            setGroupId(requestById?.group_id);
        }
    }, [requestById]);

    useEffect(() => {
        dispatch(clearPriceRequestMsg());
        if (Groups) {
            dispatch(getAllGroups());
        }
    }, []);

    const handleDataChange = () => {
        dispatch(
            updatePanelContent({
                reqName,
                oldPrice,
                newPrice,
                dateTime,
                executed,
                executedBy,
            }),
        );
    };
    const getData = () => {
        setSuccessMsg(false);
    };
    const handleSelection = cPass => {
        if (executed === 'N') {
            const params = {
                _id: requestById._id,
                control_password: cPass,
            };
            dispatch(updateExecuteRequest(params));
            setOpenModal(false);
            handleDataChange();

            setTimeout(() => {
                handleData();
            }, 3000);
            // {
            //     GroupByID.length === 0 ? setSuccessMsg(true) : null;
            // }
        } else {
            setOpenModal(false);
            setReloadBox(true);
            handleData();
        }
    };

    useEffect(() => {
        if(priceExecuteRes?.status === 'success'){
            setSuccessMsg(true)
        } else {
            setSuccessMsg(false);
        }
    }, [priceExecuteRes]);

    const renderReloadBox = () => (
        <AppConfirmDialog
            open={reloadBox}
            title="Request"
            message="Price request already executed !"
            confirmText="OK"
            cancelText="Cancel"
            onConfirm={() => setReloadBox(false)}
            onCancel={() => setReloadBox(false)}
        />
    );

    const renderSuccessMsg = () => (
        <AppConfirmDialog
            open={successMsg}
            title="Request"
            message="Price request executed successfully !"
            confirmText="OK"
            cancelText="Cancel"
            onConfirm={() => getData()}
            onCancel={() => getData()}
        />
    );

    const selectGDelete = () => {
        const params = {
            _id: deleteData._id,
        };
        dispatch(deleteExecuteRequest(params));
        setShowDialog(false);
    };

    const handleExecution = _id => {
        setOpenModal(true);

        const params = {
            _id: _id,
        };
        dispatch(getRequestID(params));
    };

    const handleRowClick = _id => {
        navigateTo(`/${ROUTE_PATHS.executorLogsByID}/${_id}`);
    };

    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };

    const handleLiveAssets = () => {
        navigateTo(`/${ROUTE_PATHS.assetsLiveData}/${id}`);
    };

    const columns = useMemo(
        () => [
            {
                field: 'date_time',
                headerName: 'Date Time For Execution',
                width: 220,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.date_time}
                        </Typography>
                    );
                },
            },
            {
                field: 'group_name',
                headerName: 'Group Name',
                width: 220,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.group_name}
                        </Typography>
                    );
                },
            },
            {
                field: 'price_request_name',
                headerName: 'Price Request Name',
                width: 220,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.price_request_name}
                        </Typography>
                    );
                },
            },
            {
                field: 'old_price',
                headerName: 'Old Price',
                width: 150,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.old_price}
                        </Typography>
                    );
                },
            },
            {
                field: 'price',
                headerName: 'New Price',
                width: 150,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.price}
                        </Typography>
                    );
                },
            },
            {
                field: 'executed',
                headerName: 'Executed',
                width: 150,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.executed}
                        </Typography>
                    );
                },
            },
            {
                field: 'executed_by',
                headerName: 'Executed By',
                width: 180,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <Typography
                            style={{
                                width: '300px',
                                height: '50px',
                                paddingTop: '12px',
                            }}
                            onClick={() => handleRowClick(params.row._id)}
                        >
                            {params.row.executed_by}
                        </Typography>
                    );
                },
            },
            {
                field: 'action',
                headerName: 'Action',
                width: 120,
                sortable: false,
                filterable: false,
                editable: true,
                textAlign: 'left',

                renderCell: params => {
                    return params.row.executed !== 'Y' ? (
                        <Button
                            style={{
                                backgroundColor: 'transparent',
                            }}
                            onClick={() => handleExecution(params.row._id)}
                        >
                            <PlayCircleFilledWhiteOutlinedIcon />
                        </Button>
                    ) : (
                        <Button>
                            <CheckCircleOutlineOutlinedIcon />
                        </Button>
                    );
                },
            },
        ],
        [],
    );
    return (
        <>
            <Paper
                variant="outlined"
                sx={{
                    // pl: 2,
                    // padding: 1,
                    marginLeft: '8px',
                    marginRight: '8px',
                }}
            >
                <Box>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        sx={{ p: 3 }}
                    >
                        <Grid item>
                            <RequestPageIcon fontSize="large" />
                        </Grid>
                        <Grid item sx={{ pl: 1 }}>
                            <Typography variant="h5">
                                Executed Price Requests By Group
                            </Typography>
                        </Grid>
                    </Grid>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        {GroupByID.length !== 0 ? (
                            <Typography
                                variant={'h6'}
                                sx={{ marginLeft: '20px' }}
                            >
                                Group Name : {GroupByID?.name}
                            </Typography>
                        ) : (
                            ''
                        )}

                        <Button
                            sx={{ margin: '10px' }}
                            variant={'outlined'}
                            onClick={() => handleLiveAssets()}
                        >
                            Station Status
                        </Button>
                    </div>
                </Box>
            </Paper>
            <div>
                {showDialog && (
                    <ConfirmationModal
                        handleCloseModal={setShowDialog}
                        handleDeleted={selectGDelete}
                    />
                )}
                {reloadBox && renderReloadBox()}
                {successMsg && renderSuccessMsg()}
            </div>

            <Box sx={{ height: '75%', width: '100%', padding: 1 }}>
                <Paper sx={{ width: '100%' }}>
                    <DataGrid
                        disableColumnMenu
                        rows={GroupByID.length === 0 ? notExecuted : request}
                        columns={columns}
                        getRowId={row => row._id}
                        rowsPerPageOptions={[10, 25, 50]}
                        autoHeight={true}
                        pageSize={pageSize}
                        onPageSizeChange={newPage => setPageSize(newPage)}
                        getRowSpacing={params => ({
                            top: params.isFirstVisible ? 0 : -2,
                            bottom: params.isLastVisible ? 0 : -2,
                        })}
                    />
                    {openModal && (
                        <ExecuteConfirmationModal
                            isOpen={openModal}
                            handleCloseModal={() => setOpenModal(false)}
                            handleControlPassword={handleSelection}
                        />
                    )}
                </Paper>
            </Box>
        </>
    );
};
//
